import { OnDestroy, Pipe, PipeTransform } from '@angular/core';

@Pipe({ name: 'fileSrc', standalone: true, pure: true })
export class FileSrcPipe implements PipeTransform, OnDestroy {
  #url: string | null = null;
  #file: File | null = null;

  transform(file: File | null | undefined): string | null {
    if (!file) {
      this.#revoke();
      return null;
    }
    if (file !== this.#file) {
      this.#revoke();
      this.#file = file;
      this.#url = URL.createObjectURL(file);
    }
    return this.#url;
  }

  ngOnDestroy(): void {
    this.#revoke();
  }

  #revoke() {
    if (this.#url) {
      URL.revokeObjectURL(this.#url);
      this.#url = null;
    }
    this.#file = null;
  }
}
